"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueue = void 0;
var react_1 = require("react");
function useQueue(_a) {
    var _b = _a.initialValues, initialValues = _b === void 0 ? [] : _b, limit = _a.limit;
    var _c = react_1.useState({
        state: initialValues.slice(0, limit),
        queue: initialValues.slice(limit),
    }), _d = _c[0], state = _d.state, queue = _d.queue, setState = _c[1];
    var add = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        return setState(function (current) {
            var results = __spreadArray(__spreadArray(__spreadArray([], current.state), current.queue), items);
            return {
                state: results.slice(0, limit),
                queue: results.slice(limit),
            };
        });
    };
    var update = function (fn) {
        return setState(function (current) {
            var results = fn(__spreadArray(__spreadArray([], current.state), current.queue));
            return {
                state: results.slice(0, limit),
                queue: results.slice(limit),
            };
        });
    };
    var cleanQueue = function () { return setState(function (current) { return ({ state: current.state, queue: [] }); }); };
    return {
        state: state,
        queue: queue,
        add: add,
        update: update,
        cleanQueue: cleanQueue,
    };
}
exports.useQueue = useQueue;
